export default __webpack_public_path__ + "static/media/diamond.15f1d740.svg";